import { Component } from "react-image-crop";
import SwalServices from "../../../services/swalServices/SwalServices";
import { saveAs } from "file-saver";
import ValidationText from "../../../utils/validation/ValidationText";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";
import PageLoader from "../../../components/common/pageLoader/PageLoader";
import moment from "moment";
import { CommonValidationMessages } from "../../../utils/Messages";
import { isValidForm, validate } from "../../../utils/validation/CommonValidator";
import CorporateMemberServices from "../../../services/axiosServices/apiServices/CorporateMemberServices";
import MetabaseDashboard from "../../../components/metabase/MetabaseDashboard";
import { MetabaseRenewalReportName, MetabaseRenewalReportQuestionId } from "../../../utils/AppSetting";
// import { getAuditContext, getAuthProps } from "../../../utils/AuthenticationLibrary";


export default class RenewalReport extends Component {
    constructor(props) {
        super(props);
        this.corporateMemberServices = new CorporateMemberServices();
        this.swalServices = new SwalServices();
        this.state = {
            generateRenewalReportRequest: {
                renewalReportStartDate: "",
                renewalReportEndDate: "",
                createdBy: 0,
                CreatedAppId: 0
            },
            renewalreportlist: [],
            isLoading: false,
            showReportFrame: false,
            validState: {
                isValid: true,
                error: {},
            },
            validationRule: {
                renewalReportStartDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "start date for renewal report"
                        ),
                    },
                ],
                renewalReportEndDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "end date for renewal report"
                        ),
                    },
                    {
                        type: "minEndDate",
                        minEndDate: "renewalReportStartDate",
                        message: "End date must be greater than start date",
                    },
                ],
            },
        };
    }

    validateField = (key) => {
        const newValidState = validate(
            key,
            this.state.generateRenewalReportRequest,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
    };

    isValidateAllFields = () => {
        const newValidState = isValidForm(
            this.state.generateRenewalReportRequest,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            generateRenewalReportRequest: {
                ...prevState.generateRenewalReportRequest,
                [name]: value,
            },
            showReportFrame: false,
        }));
    };

    generateRenewalReport = () => {
        let isValidateAllFields = this.isValidateAllFields()
        if (isValidateAllFields) {
            if (this.state.generateRenewalReportRequest.renewalReportStartDate && this.state.generateRenewalReportRequest.renewalReportEndDate) {
                this.setState({ showReportFrame: true });
            }
        }
    }

    getRenewalReportFrame = () => {
        const reportStartDate = moment(this.state.generateRenewalReportRequest.renewalReportStartDate).format("YYYY-MM-DD");
        const reportEndDate = moment(this.state.generateRenewalReportRequest.renewalReportEndDate).format("YYYY-MM-DD");

        return {
            id: 1,
            title: "",
            questionId: MetabaseRenewalReportQuestionId,
            expMinutes: 10,
            bordered: false,
            titled: false,
            parameters: {
                ReportStartdate: reportStartDate,
                ReportEnddate: reportEndDate,
            },
            fallbackUrl: `https://sgtechba.flyingcapetech.com/question/${MetabaseRenewalReportName}?ReportStartdate=${encodeURIComponent(reportStartDate)}&ReportEnddate=${encodeURIComponent(reportEndDate)}`,
            height: 900,
            showDownloadButton: false,
            downloadLabel: "Download Results",
        };
    };

    render() {
        return (
            <div className="main-body-section finance-body-sec">
                <div className="bg-white">
                    <div className="grid grid-cols-12 gap-6 w-full px-8 py-10 items-end">
                        <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                Start Date<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="renewalReportStartDate"
                                    name="renewalReportStartDate"
                                    type="date"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    value={this.state.generateRenewalReportRequest.renewalReportStartDate}
                                    onChange={this.handleChange}
                                    onBlur={() => this.validateField("renewalReportStartDate")}
                                />
                            </div>
                            <ValidationText error={this.state.validState.error.renewalReportStartDate} />
                        </div>
                        <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                End Date<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="renewalReportEndDate"
                                    name="renewalReportEndDate"
                                    type="date"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    value={this.state.generateRenewalReportRequest.renewalReportEndDate}
                                    onChange={this.handleChange}
                                    onBlur={() => this.validateField("renewalReportEndDate")}
                                />
                            </div>
                            <ValidationText error={this.state.validState.error.renewalReportEndDate} />
                        </div>
                        <div className="col-span-4 mb-1">
                            {this.state.isLoading ? <ButtonLoader /> :
                                <button className="btn btn-red text-xl border text-white mt-8" onClick={() => this.generateRenewalReport()}>
                                    Generate Renewal Report
                                </button>
                            }
                        </div>
                    </div>
                </div>
                {this.state.showReportFrame ? (
                    <div className="mt-0">
                        <MetabaseDashboard
                            title=""
                            frameCount={1}
                            frames={[this.getRenewalReportFrame()]}
                            className="px-6"
                        />
                    </div>
                ) : null}
            </div >

        );
    }
}
